import StatusbarController from './statusbarController';
import "./statusbar.scss";


const StatusbarComponent = {
    template: require('./statusbarView.html'),
    controller: StatusbarController
};

export default StatusbarComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/statusbar/statusbarComponent.js